import { LinkProps } from "@mui/material/Link";
import MuiLink from "components/MuiExtras/MuiLink";
import UsernameInspect, { UserIdResolver } from "components/UsernameInspect";
import HtmlUtils from "lib/HtmlUtils";
import { UserEntityModel, UserShortView } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from 'react-i18next';
import { RoutePaths } from "routes/RouteConfig";
import Session from "services/Session";

interface IProps {
    user: UserEntityModel | UserShortView;
}

type Props = IProps & Omit<LinkProps, "href">;

const UserFullProfileLink: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { user, color, title, ...rest } = props;
    const id = UserIdResolver(user);

    return id == Session.tenantId
        ? <i><UsernameInspect user={user} /></i>
        : (
            <MuiLink
                {...rest}
                href={null}
                color={color || "inherit"}
                title={title || t("Components.UserFullProfileLink.TitleText")}
                onClick={() => HtmlUtils.openUrlInNewWindow(RoutePaths.UserProfileViewer.replace(":id?", id))}
            >
                <UsernameInspect user={user} />
            </MuiLink>
        );
};

export default UserFullProfileLink;